export default __webpack_public_path__ + "static/media/parking-normal.0d869305.svg";